"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Button = _interopRequireDefault(require("../Button"));
var _styles = _interopRequireDefault(require("./styles"));
var _bitpay = require("../../lib/payments/bitpay");
var _BitPayLogo = _interopRequireDefault(require("./BitPayLogo"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Button to handle opening BitPay modal and returning Invoice ID.
 * @documentation https://github.com/ELEVATORmedia/duffel-bag/wiki/BitPayButton
 */
var BitPayButton = props => {
  var {
    apiUri,
    cost,
    email,
    disabled,
    handleComplete
  } = props;
  var classes = (0, _styles.default)(props);
  var theme = (0, _useTheme.default)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var [bitPayModalOpen, setBitPayModalOpen] = _react.default.useState(false);
  var bitPayIsPaid = _react.default.useRef(false);
  _react.default.useEffect(() => {
    if (window) {
      window.addEventListener('message', checkInvoicePaid);
    }
    return () => window.removeEventListener('message', checkInvoicePaid);
  }, []);
  var checkInvoicePaid = event => {
    var payment_status = event.data.status;
    if (payment_status === 'paid') {
      bitPayIsPaid.current = true;
    }
  };
  var handleBitPayButton = () => {
    setBitPayModalOpen(true);
    openBitPayModal(email, cost / 100);
  };
  var openBitPayModal = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (email, price) {
      if (window && window.bitpay) {
        var invoiceId = yield (0, _bitpay.createInvoice)(apiUri, email, price);
        var {
          bitpay
        } = window;
        // Set up modal close handlers
        bitpay.onModalWillLeave(() => {
          if (bitPayIsPaid.current) {
            setBitPayModalOpen(false);
            handleComplete(invoiceId);
          } else {
            setBitPayModalOpen(false);
          }
        });
        if (process.env.NODE_ENV === 'development') {
          console.log('BitPay test mode enabled');
          bitpay.enableTestMode();
        }
        // Open modal
        bitpay.showInvoice(invoiceId);
      }
    });
    return function openBitPayModal(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: 'contained',
    onClick: handleBitPayButton,
    disabled: disabled || bitPayModalOpen,
    size: 'large',
    fullWidth: mobile
  }, bitPayModalOpen ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    color: "inherit",
    size: 32
  }) : /*#__PURE__*/_react.default.createElement(_BitPayLogo.default, {
    className: classes.bitpayLogo
  }));
};
var _default = exports.default = BitPayButton;